import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl, useMediaQuery, useTheme, IconButton, Box, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';
const TranslateSelection = ({ selectedContent, dropdownOptions }) => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isIpad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
    const { t } = useTranslation();
    const formatSelectedText = () => {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0)
            return '';
        let selectedText = '';
        for (let i = 0; i < selection.rangeCount; i++) {
            const range = selection.getRangeAt(i);
            selectedText += range.cloneContents().textContent + ' ';
        }
        selectedText = selectedText
            .replace(/(\.)(\s*)(\d+\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)([a-zA-Z]\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)([IVXLCDM]+\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)(-)/g, '$1\n$3')
            .replace(/(\.)(\s*)(•)/g, '$1\n$3')
            .replace(/\n+/g, '\n');
        return selectedText.trim();
    };
    const handleTextCopying = (event) => {
        const textToCopy = formatSelectedText() || selectedContent;
        navigator.clipboard.writeText(textToCopy);
        const parentElement = event.currentTarget.closest('.translate-component');
        if (parentElement) {
            parentElement.style.visibility = 'hidden';
        }
    };
    return (_jsx(FormControl, { fullWidth: true, sx: { mb: isXs || isIpad ? 8 : 0 }, className: 'translate-component', children: _jsx(Box, { display: 'flex', alignItems: 'center', sx: {
                borderRadius: '6px',
                bgcolor: 'black'
            }, children: _jsx(Box, { borderRight: '1px solid white', children: _jsx(Tooltip, { title: 'Copy Text', children: _jsx(IconButton, { sx: {
                            color: 'white',
                            bgcolor: 'black',
                            borderRadius: 0,
                            '&:hover': {
                                bgcolor: '#333'
                            }
                        }, onClick: handleTextCopying, children: _jsx(ContentCopyIcon, {}) }) }) }) }) }));
};
export default TranslateSelection;
